export default Object.freeze({
  // ERR_API_
  ERROR: '오류가 발생하였습니다.', // ERR_API_ERROR
  SUCCESS: '성공',
  FAIL: '실패',
  CNT: '건',
  CONNECTION_IS_NOT_SMOOTH: '서버접속이 원활하지 않습니다. 잠시 후 재시도 해주세요.',
});
